import { render, staticRenderFns } from "./Indonesia.vue?vue&type=template&id=66ae2925&"
import script from "./Indonesia.vue?vue&type=script&lang=js&"
export * from "./Indonesia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports